<template>
  <div class="app-body">
    <router-view class="app-page"/>
  </div>
</template>

<script>
import AppMainNav from './AppMainNav';

export default {
  name: 'AppBody',
  components: {
    AppMainNav,
  },
};
</script>

<style lang="scss" scoped>
  @import '../assets/_colors.scss';
  @import '../assets/_globals.scss';

  .app-body{
    margin-top: 1rem;
    max-width: $container-width;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    padding-left: 1rem;
    padding-right: 1rem;
    box-sizing: border-box;
    h1{
      color: $red;
      margin-top: 2rem;
    }
  }

  .app-page{
    padding: 0;
    box-sizing: border-box;
  }
</style>



// WEBPACK FOOTER //
// src/components/AppBody.vue